import type { ICatalog } from '@platform/core/types';
import type { IMyWorkWireItem } from '@platform/dao';
import { moduleRank } from '../customize/moduleRank';
import { recordTypeOrder } from '../../shell/recordTypeOrder';
import type { IWorkGroup } from './IWorkGroup';

/**
 * Групи подання «Моя робота» (прототип v4 homeView): по групі на тип запису («Справи», «CRM», «Контакти», «Декларації» — у прототипі кожен
 * тип є окремим модулем простору) у порядку прототипу для простору (recordTypeOrder: `order` каталогу), записи — у порядку сервера (за
 * терміном). Тип поза каталогом — наприкінці. Чиста функція.
 */
export function workGroups(items: readonly IMyWorkWireItem[], catalog: ICatalog | undefined): IWorkGroup[] {
  const at = recordTypeOrder(catalog, moduleRank());
  const groups = new Map<string, IWorkGroup>();
  for (const item of items) {
    const group = groups.get(item.recordType) ?? { recordType: item.recordType, module: item.module, items: [] };
    group.items.push(item);
    groups.set(item.recordType, group);
  }
  return [...groups.values()].sort((a, b) => at(a.recordType) - at(b.recordType));
}
